const TENETS = [
  {
    word: "Curated.",
    line: "Every closet is hand-selected, every piece considered before it joins the wardrobe.",
  },
  {
    word: "Cared for.",
    line: "Our team manages everything from garment intake and photography to storage, dry cleaning, delivery, and protection.",
  },
  {
    word: "Delivered.",
    line: "Logistics handled end-to-end, with the care of a private atelier.",
  },
  {
    word: "Connected.",
    line: "Curated onboarding, showroom fittings, and member moments — a service-led experience.",
  },
];

export const Experience = () => {
  return (
    <section
      id="experience"
      data-testid="experience-section"
      className="relative w-full bg-[#F6F2EC] pt-24 md:pt-32 pb-12 md:pb-16"
    >
      <div className="mx-auto max-w-[1480px] px-6 md:px-10 lg:px-14">
        {/* Header */}
        <div className="max-w-3xl">
          <h2
            data-testid="experience-heading"
            className="font-editorial text-[#2B2320] text-4xl md:text-5xl lg:text-6xl leading-[1.05]"
          >
            MUSEMI <span className="font-editorial-italic">experience.</span>
          </h2>

          <div className="mt-10 md:mt-12 max-w-2xl space-y-5 text-[#2B2320] text-base md:text-lg leading-relaxed font-light">
            <p>
              Every piece on Musemi is thoughtfully managed through a hands-on experience designed to make renting and lending feel effortless.
            </p>
            <p className="text-[#8A827D]">
              Musemi brings a more thoughtful rhythm to shared fashion — blending curated closets, garment care, delivery, and future in-person experiences into one connected ecosystem.
            </p>
          </div>
        </div>

        {/* Tenets — no numbers, tighter rhythm */}
        <div className="mt-20 md:mt-28 grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-14 md:gap-y-16 max-w-5xl">
          {TENETS.map((t, i) => (
            <div
              key={t.word}
              data-testid={`experience-tenet-${i}`}
              className="flex flex-col"
            >
              <h3 className="font-editorial-italic text-[#2B2320] text-4xl md:text-5xl">
                {t.word}
              </h3>
              <p className="mt-4 text-[#2B2320]/85 font-light leading-relaxed max-w-sm">
                {t.line}
              </p>
            </div>
          ))}
        </div>

        {/* Quiet closer — tighter */}
        <div className="mt-16 md:mt-20 max-w-2xl">
          <p className="font-editorial-italic text-[#634F50] text-xl md:text-2xl leading-relaxed">
            Rent with ease. Lend with confidence. Discover with intention.
          </p>
        </div>
      </div>
    </section>
  );
};
